import { HOW_IT_WORKS } from "../../data/content";

export const HowItWorks = () => {
  return (
    <section id="how" className="py-24 md:py-32 bg-neutral-50 border-t border-neutral-200" data-testid="how-section">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-5">
            <div className="text-[11px] tracking-[0.3em] uppercase text-neutral-500 mb-4 font-medium">
              How it works
            </div>
            <h2 className="font-heading leading-[0.95] tracking-tight">
              <span className="block text-4xl md:text-6xl font-black">Procurement,</span>
              <span className="block text-4xl md:text-6xl font-thin">simplified.</span>
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7 flex items-end">
            <p className="text-base md:text-lg text-neutral-600 font-light max-w-md">
              We sell exclusively to verified medical professionals. Onboarding takes minutes — and once you&apos;re in,
              every order is tracked from cold-chain pack to your clinic.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-l border-t border-neutral-200">
          {HOW_IT_WORKS.map((s) => (
            <div
              key={s.step}
              className="border-r border-b border-neutral-200 bg-white p-8 md:p-10 min-h-[260px] flex flex-col justify-between hover:bg-black hover:text-white transition-colors group"
              data-testid={`step-${s.step}`}
            >
              <div className="font-heading text-5xl md:text-6xl font-thin tracking-tight">{s.step}</div>
              <div>
                <h4 className="font-heading text-lg font-black tracking-tight mb-2">{s.title}</h4>
                <p className="text-sm font-light text-neutral-600 group-hover:text-neutral-200 transition-colors">
                  {s.body}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
